export default {
  main: {
    site_id: 18755494,
    enableWorldCup: true,
    title: 'Terminal PRO',
    rfidPinCode: true,
    staffPassword: '0',
    websitePasswordHash: 'dc3336357738a30895329f70e5dee8d67c388db7387a17ac4c83bb4a539d238e',
    logoSize: 'big',
    unfocusForInactivity: false,
    homeMediaSlides: [
      {
        type: 'sport',
        path: 'betting/prematch',
      },
    ],
    showPopularSection: false,
    availableLanguages: {
      '@replace': true,
      spa: {
        short: 'ES',
        name: 'Esp',
        region: 'UnitedKingdom',
        order: 2,
      },
      eng: {
        short: 'EN',
        name: 'English',
        region: 'UnitedKingdom',
        order: 1,
      },
    },
  },
  splitScreen: {
    enabled: false,
  },
  verticalHome: {
    grid: [["shortpages"], ["slider"], ["comp"], ["populargames"]],
    gridColumns: "1fr",
    gridRows: "1.17fr 3fr 1.6fr 8.4fr",
    liveGamesCount: 10,
  },
  cashout: {
    enablePartial: true,
    enableByKeypress: true,
  },
  rfid: {
    logoutIfIdleSecondsCount: 60 * 30,
  },
  routes: [
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: true,
      nestedItems: [
        {
          name: 'Casino',
          type: 'casino',
          url: 'casino',
          enabled: true,
          icon: 'casino-7',
        },
        {
          name: 'Live Casino',
          type: 'liveCasino',
          url: 'liveCasino',
          enabled: true,
          icon: 'casino-categories-LotteryGames',
        },
      ],
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],

  defaultTerminalParams: {
    pid: 18755494,
    tid: 31136,
    token: 'fDisDw==',
    currency: 'CLP'
  },
  env: {
    lang: 'spa',
  },
  sportsbook: {
    sportList: {
      enablePredefinedMultiples: false
    }
  }
};
